// extracted by mini-css-extract-plugin
module.exports = {"panel":"index_panel__IIoDI"};